import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Span } from 'components/Ui';
import { isSsr } from 'utils/ssrHelper';
import { getToUrl } from 'utils/translation';
import { REVIEW_PAGE, CONFIRMATION_PAGE } from './constants';
import styles from './styles.scss';

const isCostcoWater = !isSsr() && window.isCostcoWater;

const psLinkTo = isCostcoWater
  ? '/costcowater-privacy'
  : getToUrl('/privacy-policy');
const psLinkTarget = '_blank';

const getContent = (page) => {
  const ByClickingContinue =
    "By clicking ‘continue’, I acknowledge that I have reviewed the Primo's Privacy Statement and I am familiar with its terms and understand that the information I am providing will be used as indicated in the";
  switch (page) {
    case REVIEW_PAGE:
      return isCostcoWater ? (
        <span>
          By clicking ‘Complete order’, I acknowledge that I have read and agree
          to the terms and conditions of your service set forth in the{' '}
          <Link to="/costcowater-service" target={psLinkTarget}>
            <Span>Service Agreement</Span>
          </Link>
          . I also acknowledge that I have reviewed Primo’ Privacy Statement and
          CA Notice at Collection and I am familiar with their terms and
          understand that the information I am providing will be used as
          indicated in the{' '}
          <Link to="/costcowater-privacy" target={psLinkTarget}>
            <Span>Privacy Statement</Span>
          </Link>{' '}
          and{' '}
          <Link to="/costco-ccpa" target={psLinkTarget}>
            <Span>CA Notice at Collection</Span>
          </Link>
          . I understand that I will continue to receive your products and
          services unless I cancel service which I can and do at any time by
          calling 866-407-7873. By providing your payment method information,
          you authorize Primo to place an initial $50 hold charge against your
          payment method which will be released within 30 days.
        </span>
      ) : (
        <span>
          <Span>
            By clicking ‘Complete order’, I acknowledge that I have read and
            agree to the terms and conditions of your service set forth in the
          </Span>{' '}
          <Link to="/terms-and-conditions" target="_blank">
            <Span>Service Agreement</Span>
          </Link>
          .{' '}
          <Span>
            I understand that I will continue to receive your products and
            services unless I cancel service which I can and do at any time by
            calling 866-407-7873. By providing your payment method information,
            you authorize Primo to place an initial $50 hold charge against your
            payment method which will be released within 30 days.
          </Span>
        </span>
      );
    case CONFIRMATION_PAGE:
      return null;
    default:
      return (
        <span>
          <Span
            translationKey={'ByClickingContinue'}
            defaultText={`DT:${ByClickingContinue}`}
          >
            {ByClickingContinue}
          </Span>{' '}
          <Link to={psLinkTo} target={psLinkTarget}>
            <Span>Privacy Statement</Span>
          </Link>
          .
        </span>
      );
  }
};

const Footer = ({
  additionalNote,
  match: {
    params: { page },
  },
}) => (
  <div
    className={classnames(
      styles.footer,
      page === CONFIRMATION_PAGE && !isCostcoWater && styles.confirmationFooter,
    )}
  >
    {additionalNote && <Span>{additionalNote}</Span>}
    {getContent(page)}
  </div>
);

Footer.propTypes = {
  additionalNote: PropTypes.string,
  match: PropTypes.object,
};

export default withRouter(Footer);
